import { render } from "./MainBaliseInfo.vue?vue&type=template&id=07b4d3b4&scoped=true"
import script from "./MainBaliseInfo.vue?vue&type=script&lang=js"
export * from "./MainBaliseInfo.vue?vue&type=script&lang=js"

import "./MainBaliseInfo.vue?vue&type=style&index=0&id=07b4d3b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b4d3b4"]])

export default __exports__